export default {
  categories1: [],
  categories2: []
}



// WEBPACK FOOTER //
// ./src/store/modules/category/state.js